import React, { useCallback, useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormikTextField from './FormikTextField';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

import Modal from 'react-bootstrap/Modal';
import FormikErrorMessage from './FormikErrorMessage';
import Text from './Text';
import Button from './Button';
import { hideAuthModals, showContinueRegisterModal } from '../actions/ui';
import { RootState } from '../config/store';
import { loginUser } from '../services/ApiService';
import { setUser, loginLocally, setUsersFollow } from '../actions/auth';
import { formatJoiError } from '../lib/utils';
import { getUserFollower } from '../services/ProfileService';
import { pageTrack, track } from '../services/mixpanelService';
import SocialLogin from './SocialLogin';

export interface LoginModalProps { }

const formSchema = Yup.object()
  .shape({
    email: Yup.string()
      .email()
      .required(),
    password: Yup.string().required(),
  })
  .required();

const LoginModal: React.FC<LoginModalProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [hasError, setHasError] = useState(false);
  const show = useSelector<RootState, boolean>(
    (state) => state.ui.showLoginModal,
  );



  useEffect(() => {
    (async () => {
      // setLoadingTwigs(true);
      try {
        pageTrack("login_screen")
      } catch (e) { }
    })();
  }, []);
  const handleSubmit = useCallback(
    (data: any, form: any) => {
      return (async () => {
        try {
          setHasError(false);
          const { user, token } = await loginUser(data);
          dispatch(setUser(user));
          track("login", { "loginType": "Email" })
          loginLocally(token);
          const usersFollow = await getUserFollower()
          
          dispatch(setUsersFollow(usersFollow));
          dispatch(hideAuthModals());
          window.location.reload(false);
        } catch (e) {
          setHasError(true);
          const err = formatJoiError(e.response.data.error);
          form.setErrors(err);
        }
      })();
    },
    [dispatch],
  );


  const successLogin = useCallback(async (data) => {
    console.log("data")
    console.log(data)
    if (data['is_approved_policies'] == "Not Approved")
      dispatch(showContinueRegisterModal(data));
    else {
      dispatch(setUser(data));

      loginLocally(data.token);
      const usersFollow = await getUserFollower()

      dispatch(setUsersFollow(usersFollow));
      dispatch(hideAuthModals());
      window.location.reload(false);

    }
  }, [dispatch]);

  const emailAlreadyExists=useSelector<RootState, boolean>(
    (state)=> state.ui.emailAlreadyExists,
  );
  const canClose = useSelector<RootState, boolean>(
    (state) => state.ui.canClose,
  );
  const onHide = useCallback(() => {
    if (canClose)
      dispatch(hideAuthModals());
  }, [dispatch, canClose]);
 
  return (
      <Modal
        dialogClassName={clsx(classes.modal, 'auth-modal')}
        centered
        show={show}
        onHide={onHide}
      >
          <Modal.Header className={classes.header} closeButton={canClose}>
            <Modal.Title>
              <Text className="m-0" color="white">
                Login
              </Text>
            </Modal.Title>
          </Modal.Header>
        <Modal.Body className="px-4">
          <Formik
            initialValues={{ email: '', password: '' }}
            onSubmit={handleSubmit}
            validationSchema={formSchema}
            validateOnChange
          >
            {({ handleSubmit, values, isValid, isSubmitting }) => (
              <Form onSubmit={handleSubmit}>
                <Text className={clsx(classes.paragraph, 'mt-5', 'mb-4')} uppercase>
                  Login with email
                </Text>
                {
                  emailAlreadyExists ? (
                  <Text className={clsx('my-2', classes.tomato)}>
                      User Already Exists, login please!
                  </Text>
                  ):(null)
                }
                {hasError ? (
                  <Text className={clsx('my-2', classes.tomato)}>
                    Invalid email or password
                  </Text>
                ) : null}
                
                  <FormikErrorMessage name="email" />
                  <FormikTextField
                    name="email"
                    type="email"
                    placeholder="Email address"
                    className={classes.input}
                  />

                  <FormikErrorMessage name="password" />
                  <FormikTextField
                    name="password"
                    type="password"
                    placeholder="Password"
                    className={classes.input}
                  />

                <hr />

                <Button
                  type="submit"
                  disabled={!values.email || !isValid || isSubmitting}
                  block
                >
                  <Text className="m-0" uppercase color="white">
                    Login
                  </Text>
                </Button>
              </Form>
            )}
          </Formik>
          <div className={classes.orDiv}>
            <span className={classes.orText}>OR</span>
          </div>
          <div className={classes.socialLogin}>
            <SocialLogin success={successLogin}></SocialLogin>
          </div>

        </Modal.Body>
      </Modal>
  );
};

const useStyles = createUseStyles({
  modal: {
    width: '100%',
    maxWidth: '500px',
  },
  '@media(max-width:580px)':{
    socialLogin:{
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
  },
  header: {
    borderRadius: '5px !important',
    backgroundColor: '#522583',
    borderBottomLeftRadius: '0 !important',
    borderBottomRightRadius: '0 !important',
    alignItems: 'center',
    marginBottom: '1px',

  },
  emailAlreadyExists:{
    fontWeight:'600',
    color:'#ff3838',
  },
  input: {
    marginBottom: '2rem',
    fontWeight: '500',

  },
  "@media (max-width:350px)":{
    input: {
      marginBottom: '1.5em',
    },
  },
  paragraph: {
    color: '#9D7CFA',
    fontSize: '18px',
    textAlign: 'center',
    fontWeight: '600',
    letterSpacing: '1px',
    textShadow: '2px 2px 5px rgb(0 0 0 / 30%), 0px -4px 10px rgb(255 255 255 / 30%)',
    '&:hover': {
      color: '#9D7CFA',
    },
    '&:visited': {
      color: '#9D7CFA !important',
    },
  },
  termsBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  loginBtn: {
    color: '#9D7CFA',
    background: 'none',
    border: 'none',
  },
  tomato: {
    color: 'tomato !important',
    fontSize: '1.2em',
  },
  orDiv: {
    height: "2px",
    backgroundColor: "#522583",
    margin: "22px 0px",
    position: "relative"
  },
  
  orText: {
    position: "absolute",
    left: "calc(50% - 17px)",
    top: "-10px",
    color: "#522583",
    backgroundColor: "white",
    padding: "0px 5px"
  },
  socialLogin: {
    padding: '1em 0',
    display: "flex",
    justifyContent: "space-evenly"
  }
});

export default LoginModal;
